<div>
	<span>
		{{ eCallOffSubmissionMessage }}
	</span>
</div>
<div class="ecall-off-follow-up">
	<span class="ecall-off-follow-up-text" translate>
		ecall-off.followup
	</span>
</div>